// extracted by mini-css-extract-plugin
module.exports = {"social-link-list":"Socials_social-link-list__wdhFU"};